import {ReactElement} from 'react';
import {
  Box,
  Typography,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemIcon
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import FavoriteIcon from '@material-ui/icons/Favorite';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import PublishIcon from '@material-ui/icons/Publish';
import TimelineIcon from '@material-ui/icons/Timeline';
import Image from 'material-ui-image';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {LOGIN} from 'anonymous/routing/paths';
import logo from 'images/logo-bella-aurora.svg';
import {PATIENT_EVOLUTION, TEST_REQUEST} from 'patient/routing/paths';
import usePublicUser from 'public/hooks/usePublicUser';
import {USER_HOME} from 'shared/routing/paths';

const useStyles = makeStyles(theme => ({
  bottomNavigation: {
    backgroundColor: theme.palette.primary.main,
    background: `-webkit-gradient(linear, left top, right bottom, from(${theme.palette.secondary.main}), to(${theme.palette.primary.main}))`,
    color: theme.palette.common.white,
    '& .MuiListItemIcon-root': {
      color: theme.palette.common.white
    }
  }
}));

function Footer(): ReactElement {
  const classes = useStyles();
  const {t} = useTranslation(['public/common']);
  const user = usePublicUser();
  return (
    <Box pt={4} px={3} pb={10} className={classes.bottomNavigation}>
      <Container maxWidth="lg">
        <Grid spacing={4} container>
          <Grid item xs={12} sm={4}>
            <Image src={logo} aspectRatio={3.3} color="transparent" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <List>
              <ListItem button to={user ? USER_HOME : LOGIN} component={Link}>
                <ListItemIcon>
                  <MeetingRoomIcon color="inherit" />
                </ListItemIcon>
                <ListItemText primary={user ? t('public/common:home') : t('public/common:login')} />
              </ListItem>
              <ListItem button to={user ? TEST_REQUEST : LOGIN} component={Link}>
                <ListItemIcon>
                  <PublishIcon color="inherit" />
                </ListItemIcon>
                <ListItemText primary={t('public/common:uploadImage')} />
              </ListItem>
              <ListItem button to={user ? PATIENT_EVOLUTION : LOGIN} component={Link}>
                <ListItemIcon>
                  <TimelineIcon color="inherit" />
                </ListItemIcon>
                <ListItemText primary={t('public/common:evolution')} />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} sm={4}>
            <List>
              <ListItem button component="a" href="https://bella-aurora.com/">
                <ListItemIcon>
                  <FavoriteIcon color="inherit" />
                </ListItemIcon>
                <ListItemText primary="Bella Aurora" />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Footer;
